function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless, api } from "@opentiny/vue-renderless/image-viewer/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconClose, iconChevronLeft, iconChevronRight, iconZoomOut, iconZoomIn, iconRepeat, iconRefres, iconDel } from "@opentiny/vue-icon";
import { directive } from "@opentiny/vue-common";
import { isObject } from "@opentiny/vue-renderless/common/type";
var TinyTouch = /* @__PURE__ */ function() {
  function TinyTouch2(element, tinyBinding, type) {
    var that = this;
    that.element = element;
    that.tinyBinding = tinyBinding;
    that.touchType = type;
    that.tinyVueTouches = {
      x: 0,
      y: 0
    };
    that.tinyVueMoves = true;
    that.tinyVueLeave = true;
    that.tinyLongTouch = true;
    that.tinyVueCallBack = isObject(tinyBinding.value) ? tinyBinding.value.fn : tinyBinding.value;
    that.element.addEventListener("touchstart", function(e) {
      that.start(e);
    });
    that.element.addEventListener("touchend", function(e) {
      that.end(e);
    });
    that.element.addEventListener("touchmove", function(e) {
      that.move(e);
    });
  }
  var _proto = TinyTouch2.prototype;
  _proto.start = function start(e) {
    var _this = this;
    if (e.touches >= 2) {
      return;
    }
    this.tinyVueMoves = true;
    this.tinyVueLeave = true;
    this.tinyLongTouch = true;
    this.tinyVueTouches = {
      x: e.changedTouches[0].pageX,
      y: e.changedTouches[0].pageY
    };
    this.time = setTimeout(function() {
      if (_this.tinyVueLeave && _this.tinyVueMoves) {
        _this.touchType == "longtap" && _this.tinyVueCallBack(_this.tinyBinding.value, e);
        _this.tinyLongTouch = false;
      }
    }, 1e3);
  };
  _proto.end = function end(e) {
    if (e.touches >= 2) {
      return;
    }
    var disX = e.changedTouches[0].pageX - this.tinyVueTouches.x;
    var disY = e.changedTouches[0].pageY - this.tinyVueTouches.y;
    clearTimeout(this.time);
    if (Math.abs(disX) > 10 || Math.abs(disY) > 100) {
      this.touchType == "swipe" && this.tinyVueCallBack(this.tinyBinding.value, e);
      if (Math.abs(disX) > Math.abs(disY)) {
        if (disX > 10) {
          this.touchType == "swiperight" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
        if (disX < -10) {
          this.touchType == "swipeleft" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
      } else {
        if (disY > 10) {
          this.touchType == "swipedown" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
        if (disY < -10) {
          this.touchType == "swipeup" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
      }
    } else {
      if (this.tinyLongTouch && this.tinyVueMoves) {
        this.touchType == "tap" && this.tinyVueCallBack(this.tinyBinding.value, e);
        this.tinyVueLeave = false;
      }
    }
  };
  _proto.move = function move() {
    this.tinyVueMoves = false;
  };
  return TinyTouch2;
}();
var mapDirective = function mapDirective2() {
  var deactives = {};
  var names = ["tap", "swipe", "swipeleft", "swiperight", "swipedown", "swipeup", "longtap"];
  names.forEach(function(name) {
    deactives[name] = directive({
      vTouch: {
        bind: function bind(el, tinyBinding) {
          new TinyTouch(el, tinyBinding, name);
        }
      }
    }).vTouch;
  });
  return deactives;
};
var touchDeactives = mapDirective();

import "@opentiny/vue-theme-mobile/image-viewer/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

import "@opentiny/vue-renderless/common/type";
var __vue2_script = defineComponent({
  props: [].concat(props, ["urlList", "zIndex", "onSwitch", "onClose", "previewVisible", "closeShow", "arrowShow", "toolShow", "showIndex", "imageFullCurrent", "startPosition", "asyncClose", "deleteButton"]),
  components: {
    IconClose: iconClose(),
    IconChevronLeft: iconChevronLeft(),
    IconChevronRight: iconChevronRight(),
    IconZoomOut: iconZoomOut(),
    IconZoomIn: iconZoomIn(),
    IconRepeat: iconRepeat(),
    IconRefres: iconRefres(),
    IconDel: iconDel()
  },
  directives: _extends({}, touchDeactives),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", {
    attrs: {
      "name": "viewer-fade"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.previewVisible,
      expression: "state.previewVisible"
    }, {
      name: "swipeleft",
      rawName: "v-swipeleft",
      value: _vm.swipeLeft,
      expression: "swipeLeft"
    }, {
      name: "swiperight",
      rawName: "v-swiperight",
      value: _vm.swipeRight,
      expression: "swipeRight"
    }],
    ref: "imagePreview",
    staticClass: "tiny-mobile-image-viewer__wrapper",
    style: {
      "z-index": _vm.zIndex
    },
    on: {
      "click": _vm.handleVisible
    }
  }, [_c("div", {
    staticClass: "tiny-mobile-image-viewer__mask"
  }), _vm.closeShow ? _c("span", {
    staticClass: "tiny-mobile-image-viewer__btn tiny-mobile-image-viewer__close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleVisible.apply(null, arguments);
      }
    }
  }, [_c("icon-close", {
    staticClass: "tiny-svg-size"
  })], 1) : _vm._e(), _vm.showIndex ? _c("div", {
    staticClass: "tiny-mobile-image-viewer__btn tiny-mobile-image-viewer__index"
  }, [_vm._t("index", function() {
    return [_c("span", {
      staticClass: "tiny-mobile-image-viewer__index--curren"
    }, [_vm._v(_vm._s(_vm.state.index + 1))]), _c("span", [_vm._v("/")]), _c("span", {
      staticClass: "tiny-mobile-image-viewer__index--total"
    }, [_vm._v(_vm._s(_vm.urlList.length))])];
  }, {
    "value": _vm.state.index + 1
  })], 2) : _vm._e(), !_vm.state.isSingle && _vm.arrowShow ? [_c("span", {
    staticClass: "tiny-mobile-image-viewer__btn tiny-mobile-image-viewer__prev",
    class: {
      "is-disabled": !_vm.state.infinite && _vm.state.isFirst,
      "is-arrow-disabled": _vm.state.arrowStyle === "N"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.swipeRight.apply(null, arguments);
      }
    }
  }, [_c("icon-chevron-left", {
    staticClass: "tiny-svg-size"
  })], 1), _c("span", {
    staticClass: "tiny-mobile-image-viewer__btn tiny-mobile-image-viewer__next",
    class: {
      "is-disabled": !_vm.state.infinite && _vm.state.isLast,
      "is-arrow-disabled": _vm.state.arrowStyle === "Y"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.swipeLeft.apply(null, arguments);
      }
    }
  }, [_c("icon-chevron-right", {
    staticClass: "tiny-svg-size"
  })], 1)] : _vm._e(), _vm.toolShow ? _c("div", {
    staticClass: "tiny-mobile-image-viewer__btn tiny-mobile-image-viewer__actions"
  }, [_c("div", {
    staticClass: "tiny-mobile-image-viewer__actions-inner"
  }, [_vm._t("tool", function() {
    return [_c("icon-zoom-out", {
      staticClass: "tiny-svg-size",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleActions("zoomOut");
        }
      }
    }), _c("icon-zoom-in", {
      staticClass: "tiny-svg-size",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleActions("zoomIn");
        }
      }
    }), _c("icon-repeat", {
      staticClass: "tiny-svg-size",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleActions("anticlocelise");
        }
      }
    }), _c("icon-refres", {
      staticClass: "tiny-svg-size",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleActions("clocelise");
        }
      }
    }), _vm.deleteButton ? _c("icon-del", {
      staticClass: "tiny-svg-size",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleDelete();
        }
      }
    }) : _vm._e()];
  })], 2)]) : _vm._e(), _c("div", {
    staticClass: "tiny-mobile-image-viewer__canvas"
  }, [_c("div", {
    staticClass: "tiny-mobile-image-viewer__wrap",
    style: {
      width: _vm.state.iamgeAllWidth + "px",
      "transition-duration": _vm.state.imageTransition + "ms",
      transform: "translateX(" + _vm.state.imageTransformSize + "px)"
    }
  }, _vm._l(_vm.state.urlList, function(url, i) {
    return _c("div", {
      key: i,
      staticClass: "tiny-mobile-image-viewer__item",
      style: Object.assign({
        width: _vm.state.imageItemWidth + "px"
      }, i === _vm.state.index ? _vm.state.imgStyle : "")
    }, [_c("div", {
      staticClass: "tiny-mobile-image-viewer__detail",
      staticStyle: {
        "transition-duration": "0.3s"
      }
    }, [_c("img", {
      key: url,
      ref: "img_" + i,
      refInFor: true,
      staticClass: "tiny-mobile-image-viewer__img",
      class: {
        "is-full-screen": _vm.state.fullScreen
      },
      attrs: {
        "src": url
      },
      on: {
        "load": _vm.handleImgLoad,
        "error": _vm.handleImgError,
        "mousedown": _vm.handleMouseDown,
        "touchstart": _vm.touchstart,
        "touchmove": _vm.touchmove,
        "touchend": _vm.touchend
      }
    })])]);
  }), 0)])], 2)]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobile = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobile as default
};
